import { CircularProgress } from "@mui/material";
import { isApplicationReadySelector } from "@repo/logic";
import { type FC } from "react";
import { useSelector } from "react-redux";
import { useSmartAction } from "../Contract/SmartAction/context";
import { StyledBackdrop } from "./StepperLoader.styled";

export const StepperLoader: FC = () => {
    const isAppReady = useSelector(isApplicationReadySelector);
    const { action } = useSmartAction();

    return (
        <StyledBackdrop open={!isAppReady && Boolean(action)}>
            <CircularProgress color="inherit" />
        </StyledBackdrop>
    );
};
